<template lang="pug">
  v-dialog(
    :value="true"
    v-bind="dialogProps"
    persistent
  )
    v-card.pa-4(v-bind="DIALOG_TYPES_DATA[type].cardAttrs")
      v-card-title(v-if="title" v-bind="DIALOG_TYPES_DATA[type].cardTitleAttrs")
        v-icon.mr-2(
          v-if="DIALOG_TYPES_DATA[type].icon"
          v-bind="DIALOG_TYPES_DATA[type].cardTitleAttrs"
        ) {{ DIALOG_TYPES_DATA[type].icon }}
        h4 {{ title }}
      v-card-text.mt-4.subtitle-1(v-bind="DIALOG_TYPES_DATA[type].cardTextAttrs")
        .mb-5(
          v-html="message"
        )

        component(
          :is="component"
          v-bind="componentProps"
        )
      v-card-actions
        v-btn.px-4(
          color="success"
          :loading="loading"
          @click="accept"
        ) {{ acceptBtnText }}
        v-spacer
        v-btn.px-4(
          @click="decline"
        ) {{ cancelBtnText }}
</template>

<script>
const DIALOG_TYPES_DATA = {
  info: {
    cardAttrs: {
      color: 'white',
    },
    cardTitleAttrs: {
      class: ['accent--text'],
    },
    cardTextAttrs: {
      class: ['dark--text'],
    },
    icon: 'mdi-information',
  },
  warning: {
    cardAttrs: {
      color: 'white',
    },
    cardTitleAttrs: {
      class: ['warning--text'],
    },
    cardTextAttrs: {
      class: ['warning--text'],
    },
    icon: 'mdi-alert',
  },
  error: {
    cardAttrs: {
      color: 'error darken-1',
    },
    cardTitleAttrs: {
      class: ['white--text'],
    },
    cardTextAttrs: {
      class: ['white--text'],
    },
    icon: 'mdi-alert',
  },
  default: {
    cardAttrs: {},
    cardTextAttrs: {},
    icon: '',
  },
};

export default {
  props: {
    title: { type: String, default: 'Подтвердите действие' },
    message: { type: String, default: 'Подтвердить действие?' },
    component: { type: [Object, String], default: null },
    componentProps: { type: Object, default: () => ({}) },

    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },

    method: { type: Function, default: null },

    acceptBtnText: { type: String, default: 'Подтвердить' },
    cancelBtnText: { type: String, default: 'Отмена' },

    type: { type: String, default: 'info' },
  },
  data: () => ({
    dialog: false,
    loading: false,
    DIALOG_TYPES_DATA,
  }),
  methods: {
    decline() {
      this.$modals.close();
    },
    async accept() {
      this.loading = true;
      if (this.method) {
        await this.method();
      }
      this.$modals.close();
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmModalText {
  line-height: 1.3rem;
}
.confirmModalTitle {
  font-size: 1.2rem;
  &:after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    margin-top: 8px;
    background: rgba(var(--black-color), 0.6);
  }
}
</style>
